"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  MEDIAMANAGER_URL: 'https://mediamanager.sportnet.online'
};